import { Container } from './Container'
import { ButtonToneContext, IconButtonToneContext } from './contexts'
import { DocumentationLink } from './DocumentationLink'

export const PageHeader = ({
  action,
  breadcrumbs,
  helpDirection = 'right',
  helpHref,
  helpLabel = 'Docs',
  meta,
  subtitle,
  title,
  titleAccessory,
}) => (
  <header className="ds-page-hero tw:text-foreground-inverse">
    <Container className="tw:flex tw:min-h-[200px] tw:items-center tw:justify-between tw:gap-8 tw:py-10 tw:mobile:min-h-0 tw:mobile:flex-col tw:mobile:items-stretch tw:mobile:gap-5 tw:mobile:py-8">
      <div className="tw:min-w-0 tw:max-w-[720px]">
        {breadcrumbs && <div className="tw:mb-4 tw:text-sm tw:text-foreground-inverse/65">{breadcrumbs}</div>}
        <div className="tw:flex tw:items-center tw:gap-3">
          <h1 className="ds-heading-2 tw:text-foreground-inverse">{title}</h1>
          {titleAccessory && (
            <IconButtonToneContext.Provider value="hero">
              {titleAccessory}
            </IconButtonToneContext.Provider>
          )}
          {helpHref && (
            <DocumentationLink
              direction={helpDirection}
              href={helpHref}
              icon="help"
              label={helpLabel}
              tone="inverse"
            />
          )}
        </div>
        {subtitle && <div className="tw:mt-4 tw:max-w-[680px] tw:text-lg tw:text-foreground-inverse/62">{subtitle}</div>}
        {meta && <div className="tw:mt-4 tw:text-base tw:text-foreground-inverse/65">{meta}</div>}
      </div>
      {action && (
        <ButtonToneContext.Provider value="hero">
          <div className="tw:flex tw:shrink-0 tw:items-center tw:gap-2 tw:mobile:[&>*]:flex-1">{action}</div>
        </ButtonToneContext.Provider>
      )}
    </Container>
  </header>
)
